export default __webpack_public_path__ + "static/media/horsehead.ee1d1986.png";